// src/api/notes/notes.ts (USER APP)
import { api } from "../api";
import { trackEvent } from "../../utils/analytics";
import type {
    NoteCreateRequest,
    NoteMetaResponse,
    NoteResponse,
    NoteUpdateRequest,
} from "./notes.types";

export const userNotesApi = {
    async listNotes(): Promise<NoteMetaResponse[]> {
        const response = await api.get<NoteMetaResponse[]>("/notes");
        return Array.isArray(response.data) ? response.data : [];
    },

    async getNote(noteId: string): Promise<NoteResponse> {
        const response = await api.get<NoteResponse>(`/notes/${noteId}`);
        return response.data;
    },

    async createNote(data: NoteCreateRequest): Promise<NoteResponse> {
        const response = await api.post<NoteResponse>("/notes", data);
        trackEvent('note_created');
        return response.data;
    },

    async updateNote(
        noteId: string,
        data: NoteUpdateRequest,
    ): Promise<NoteResponse> {
        const response = await api.patch<NoteResponse>(
            `/notes/${noteId}`,
            data,
        );
        return response.data;
    },

    async deleteNote(noteId: string): Promise<{ success: boolean }> {
        await api.delete(`/notes/${noteId}`);
        trackEvent('note_deleted');
        return { success: true };
    },
};
